import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#E4B670",
    "col1n": "#D19532",
    "col2n": "#FFFFFF"
}
function SkiWou008({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M9.85.3Q7.5-.4 4.95.55q-2.6.95-4 2.85Q-.4 5.35.15 7.2L7.8 28.6l.05.1.45 1.2h.1L9.8 34q.65 1.75 2.85 2.35 2.35.75 4.95-.2 2.6-.9 4-2.95.95-1.45.9-2.85-.05-.3-.1-.55h-.05l-.1-.3L12.8 2.8Q12.1 1.05 9.85.3z"
                    id="SkiWou008__Symbol_42_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M7.9 28.95l.05.1 1.9 5.4q.65 1.75 2.85 2.35 2.35.75 4.95-.2 2.6-.9 4-2.95 1.3-1.95.7-3.8L20.4 24.4 7.9 28.95M.15 7.2l2.1 5.65 12.6-4.25-2.05-5.8Q12.1 1.05 9.85.3 7.5-.4 4.95.55q-2.6.95-4 2.85Q-.4 5.35.15 7.2z"
                    id="SkiWou008__Symbol_29_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M4.5 7.85q-.6-.25-1.3 0-.7.2-1 .85-.35.65-.05 1.4.2.6.85.95.7.35 1.4.15.65-.3.95-1 .35-.65.1-1.3-.25-.75-.95-1.05M.1 4.35q.25.7.9 1 .7.3 1.4.1.7-.25 1-.95.3-.6.1-1.3-.25-.7-.95-1-.65-.3-1.35-.1-.7.25-1 .9-.3.65-.1 1.35m6.6-1q.7.35 1.4.1.6-.25 1-1 .3-.6 0-1.2Q8.9.5 8.2.2 7.55-.15 6.95.15q-.75.2-1.1.85-.3.7-.05 1.4.3.6.9.95m4.45 3.45q-.25-.6-.9-.95-.7-.3-1.35-.1-.65.3-1 1-.3.6-.05 1.25.2.7.85 1 .7.35 1.35.1.65-.25 1-.9t.1-1.4z"
                    id="SkiWou008__Symbol_30_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiWou008__Symbol_42_0_Layer0_0_FILL"
                transform="translate(120.55 181.45)"
                id="SkiWou008__col1n"
            />
            <use
                xlinkHref="#SkiWou008__Symbol_29_0_Layer0_0_FILL"
                transform="translate(120.45 181.1)"
                id="SkiWou008__col1l"
            />
            <use
                xlinkHref="#SkiWou008__Symbol_30_0_Layer0_0_FILL"
                transform="translate(126.1 194.05)"
                id="SkiWou008__col2n"
            />
        </g></g>
    )
}
export default SkiWou008
